import { useSetAtom } from 'jotai'
import { selectAtom } from 'jotai/utils'
import { useCallback } from 'react'
import type {
  CityId,
  LargeAreaCode,
  MediumAreaCode,
  MinimumAreaCode,
  SmallAreaCode,
  TownId,
} from '~/lib/graphql/scalars'
import { draftSearchCriteria$ } from './draft'
import type { SearchCriteria } from './validate'

export const draftLargeAreaCode$ = selectAtom(draftSearchCriteria$, (s) => s?.largeAreaCode)
draftLargeAreaCode$.debugLabel = 'draftLargeAreaCode$'

export const draftMediumAreaCode$ = selectAtom(draftSearchCriteria$, (s) => s?.mediumAreaCode)
draftMediumAreaCode$.debugLabel = 'draftMediumAreaCode$'

export function useSetDraftMediumArea() {
  const set = useSetAtom(draftSearchCriteria$)
  return useCallback(
    (largeAreaCode: LargeAreaCode, mediumAreaCode: MediumAreaCode) => {
      set((current) => changeMediumArea(current, largeAreaCode, mediumAreaCode))
    },
    [set]
  )
}

export function useDraftRemoveArea() {
  const set = useSetAtom(draftSearchCriteria$)
  return useCallback(() => {
    set((current) => {
      const {
        largeAreaCode,
        mediumAreaCode,
        smallAreaCodes,
        minimumAreaCodes,
        cityId,
        townId,
        ...removed
      } = current ?? {}
      return removed
    })
  }, [set])
}

function changeMediumArea(
  current: SearchCriteria | undefined,
  largeAreaCode: LargeAreaCode,
  mediumAreaCode: MediumAreaCode
): SearchCriteria {
  const { smallAreaCodes, minimumAreaCodes, cityId, townId, ...removed } = current ?? {}
  return { ...removed, largeAreaCode, mediumAreaCode }
}
if (import.meta.vitest) {
  const { describe, it, expect } = import.meta.vitest
  describe('changeMediumArea', () => {
    it('小エリア以下はリセットされる', () => {
      const current: SearchCriteria = {
        largeAreaCode: '07' as LargeAreaCode,
        mediumAreaCode: '002' as MediumAreaCode,
        smallAreaCodes: ['001'] as SmallAreaCode[],
        minimumAreaCodes: ['0094'] as MinimumAreaCode[],
      }
      const result = changeMediumArea(current, '03' as LargeAreaCode, '001' as MediumAreaCode)
      expect(result).toStrictEqual({
        largeAreaCode: '03',
        mediumAreaCode: '001',
      })
    })
    it('市区町村リセットされる', () => {
      const current: SearchCriteria = {
        largeAreaCode: '07' as LargeAreaCode,
        mediumAreaCode: '002' as MediumAreaCode,
        cityId: '10631' as CityId,
        townId: '6060001001' as TownId,
      }
      const result = changeMediumArea(current, '03' as LargeAreaCode, '001' as MediumAreaCode)
      expect(result).toStrictEqual({
        largeAreaCode: '03',
        mediumAreaCode: '001',
      })
    })
  })
}
